import React from "react";
import Navbar from "./components/navbar";
import CreateSmartketComponent from "./create/create.component";
import CreateSmartketProvider from "./create/provider/createSmartket.provider";
import CreateUsedSmartketProvider from "./create/used/provider/createUsedSmartket.provider";
import CreateNewsSmartketProvider from "./create/news/provider/createNewsSmartket.provider";

const SmartketPage = () => {
  return (
    <CreateSmartketProvider>
      <CreateNewsSmartketProvider>
        <CreateUsedSmartketProvider>
          <div className="h-screen overflow-auto bg-gradient-to-b from-white to-[#f04c11]">
            <Navbar />
            <section className="flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateSmartketComponent />
              </div>
            </section>
          </div>
        </CreateUsedSmartketProvider>
      </CreateNewsSmartketProvider>
    </CreateSmartketProvider>
  );
};

export default SmartketPage;
